// Trigger a browser download for a binary payload received via axios
// (`responseType: "arraybuffer"`). Object URL is revoked after the click so the
// blob can be GC'd. Used by every binary download in the app.
export const downloadBlob = (data: ArrayBuffer, filename: string, mime: string): void => {
	const blob = new Blob([data], { type: mime });
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	a.remove();
	URL.revokeObjectURL(url);
};
